import "../scss/style.scss";

import Slider from "./modules/slider";
import Map from "./modules/map";
import MainMenu from "./modules/mainMenu";
import PhoneButton from "./modules/phoneButton";
import Realisation from "./modules/realisation";
import { InitContactEvents } from "./modules/contact";
import ReadMore from "./modules/readMore";

const $inspirationSlider = document.querySelector('[data-role="slider-inspiration"]');
if ($inspirationSlider) {
    const sliderInsipiration = new Slider($inspirationSlider, '.inspiration-section');
}

const $heroHomeSlider = document.querySelector('[data-role="slider-home"]');
if ($heroHomeSlider) {
    const sliderHome = new Slider($heroHomeSlider, '.hero-home');
}

const $map = document.querySelector('#map');
if ($map) {
    const map = new Map($map)
}

const $mainMenu = document.querySelector('[data-role="main-menu"]');
if ($mainMenu) {
    const mainMenu = new MainMenu();
}

const $phoneButton = document.querySelector('[data-role="phone-number"]');
if ($phoneButton) {
    const phoneButton = new PhoneButton($phoneButton);
}

const $contactForm = document.querySelector('.wpcf7-form');
if ($contactForm) {
    InitContactEvents($contactForm);
}

const $readMoreBlocks = document.querySelectorAll('[data-role="read-more"]');
if ($readMoreBlocks) {
    $readMoreBlocks.forEach(($elt) => {
        new ReadMore($elt);
    })
}

document.addEventListener('DOMContentLoaded', () => {
    const $realisations = document.querySelectorAll('[data-role="realisation"]')
    if ($realisations.length) {
        const realisation = new Realisation($realisations);
    }
})



